import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  IoChevronBack, 
  IoChevronForward, 
  IoVolumeMute, 
  IoVolumeHigh, 
  IoReload 
} from 'react-icons/io5';
import '../style/carousal.css';

// ─── VIDEO IMPORTS ────────────────────────────────────────────────
// VFX & HYPERLAPSE (8 reels)
import vfxHyp1 from '../../assets/reels/vfx & hyperlaspe/Oddd.mp4';
import vfxHyp2 from '../../assets/reels/vfx & hyperlaspe/Buggy.mp4';
import vfxHyp3 from '../../assets/reels/vfx & hyperlaspe/Burmano.mp4';
import vfxHyp4 from '../../assets/reels/vfx & hyperlaspe/Careereaaaa.mp4';
import vfxHyp5 from '../../assets/reels/vfx & hyperlaspe/Drip By Rage.mp4';
import vfxHyp6 from '../../assets/reels/vfx & hyperlaspe/Eden 2.mp4';
import vfxHyp7 from '../../assets/reels/vfx & hyperlaspe/Found Some Aesthetics In This Outlet And Thought Of Giving It My Touch. Really Liked Their Fragr.mp4';
import vfxHyp8 from '../../assets/reels/vfx & hyperlaspe/Gamepar.mp4';
import vfxHyp9 from '../../assets/reels/vfx & hyperlaspe/Kia.mp4';
import vfxHyp10 from '../../assets/reels/vfx & hyperlaspe/Laptop 1.mp4';
import vfxHyp11 from '../../assets/reels/vfx & hyperlaspe/Lahore~1.mp4';
import vfxHyp12 from '../../assets/reels/vfx & hyperlaspe/S=Za Gaming.mp4';
import vfxHyp13 from '../../assets/reels/vfx & hyperlaspe/String Vffx.mp4';
import vfxHyp14 from '../../assets/reels/vfx & hyperlaspe/We Play.mp4';
import vfxHyp15 from '../../assets/reels/vfx & hyperlaspe/Boc 2.mp4';


// CGI (7 reels)
import cgi1 from '../../assets/reels/cgi/Brim Final.mp4';
import cgi2 from '../../assets/reels/cgi/Car Cgi 2.mp4';
import cgi3 from '../../assets/reels/cgi/Img 5783.mp4';
import cgi4 from '../../assets/reels/cgi/Inshot 20250325 173420235.mp4';
import cgi5 from '../../assets/reels/cgi/Od.mp4';


// EVENTS (7 reels)
import events1 from '../../assets/reels/events/Metro.mp4';
import events2 from '../../assets/reels/events/Pepsi.mp4';
import events3 from '../../assets/reels/events/Rcm 2.mp4';
import events4 from '../../assets/reels/events/Sahulat Markaz Final.mp4';
import events5 from '../../assets/reels/events/Sol Fest 1.mp4';
import events6 from '../../assets/reels/events/Unilever.mp4';
import events7 from '../../assets/reels/events/Sould Fst Lhr.mp4';
// FASHION (7 reels)
import fashion1 from '../../assets/reels/fashion/Burmano.mp4';
import fashion2 from '../../assets/reels/fashion/Drip By Rage.mp4';
import fashion3 from '../../assets/reels/fashion/Fashion Shoes.mp4';
import fashion4 from '../../assets/reels/fashion/Fasshion 2.mp4';
import fashion5 from '../../assets/reels/fashion/Fawad 2.mp4';
import fashion6 from '../../assets/reels/fashion/Funkari Post.mp4';
import fashion7 from '../../assets/reels/fashion/Inshot 20250821 205436397.mp4';
import fashion8 from '../../assets/reels/fashion/Inshot 20251205 205128496.mp4';
import fashion9 from '../../assets/reels/fashion/Reel 1.mp4';
import fashion10 from '../../assets/reels/fashion/The Art Of Speed.mp4';

// FOOD (7 reels)
import food1 from '../../assets/reels/food/Contra Cafe 3.mp4';
import food2 from '../../assets/reels/food/Contra Coffe.mp4';
import food3 from '../../assets/reels/food/Csd.mp4';
import food4 from '../../assets/reels/food/Flitta2 Reel Full.mp4';
import food5 from '../../assets/reels/food/Fluree.mp4';
import food6 from '../../assets/reels/food/Karchi.mp4';
import food7 from '../../assets/reels/food/Mr Wow.mp4';
import food8 from '../../assets/reels/food/Omnomfries.mp4';
import food9 from '../../assets/reels/food/Puloa.mp4';
import food10 from '../../assets/reels/food/String Vffx.mp4';

// INDUSTRY (7 reels)
import industry1 from '../../assets/reels/industry/Narmin Fac1.mp4';
import industry2 from '../../assets/reels/industry/Factory Star 3.mp4';
import industry3 from '../../assets/reels/industry/Imito Music Change.mp4';
import industry4 from '../../assets/reels/industry/JabChaho.mp4';
import industry5 from '../../assets/reels/industry/Narkins Final.mp4';
import industry6 from '../../assets/reels/industry/Multsn X Fatima 2.mp4';
import industry7 from '../../assets/reels/industry/No Logo And Text.mp4';

// REAL ESTATE (7 reels)
import realestate1 from '../../assets/reels/real state/Fd Tiles 3.mp4';
import realestate2 from '../../assets/reels/real state/Faizaia Society.mp4';
import realestate3 from '../../assets/reels/real state/Fsd.mp4';
import realestate4 from '../../assets/reels/real state/Inshot 20241102 192423608.mp4';
import realestate5 from '../../assets/reels/real state/Inshot 20250730 190157690.mp4';
import realestate6 from '../../assets/reels/real state/Luxury Hill Final.mp4';
import realestate7 from '../../assets/reels/real state/Main Beach.mp4';
import realestate8 from '../../assets/reels/real state/Ngs Revised 4K.mp4';
import realestate9 from '../../assets/reels/real state/Pakages Mall Revised Version.mp4';
import realestate10 from '../../assets/reels/real state/Upcountru.mp4';

// SPEEDRAMPING (7 reels)
import speed1 from '../../assets/reels/speed ramping/#Reels #Vfx #Videooftheday #Hyperlapse #Viralreels #Lums #Nest.mp4';
import speed2 from '../../assets/reels/speed ramping/Bts 2.mp4';
import speed3 from '../../assets/reels/speed ramping/Build Pro Fix.mp4';
import speed4 from '../../assets/reels/speed ramping/Funnation 1St Video Final Video With Sfx.mp4';
import speed5 from '../../assets/reels/speed ramping/Gamestop.mp4';
import speed6 from '../../assets/reels/speed ramping/Img 5783.mp4';
import speed7 from '../../assets/reels/speed ramping/Inshot 20241102 192423608.mp4';
import speed8 from '../../assets/reels/speed ramping/Inshot 20251205 205128496.mp4';
import speed9 from '../../assets/reels/speed ramping/Inshot 20250325 173420235.mp4';
import speed10 from '../../assets/reels/speed ramping/Snooker Karcahi.mp4';
import speed11 from '../../assets/reels/speed ramping/Toy Shop.mp4';
import speed12 from '../../assets/reels/speed ramping/Super Space Reel Audio.mp4';
import speed13 from '../../assets/reels/speed ramping/Main Beach.mp4';




// ─── DATA ─────────────────────────────────────────────────────────
const reels = [
  // ALL category includes everything - will be filtered dynamically
  
  // VFX & HYPERLAPSE
  { id: 'vfxHyp-1', src: vfxHyp1, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-2', src: vfxHyp2, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-3', src: vfxHyp3, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-4', src: vfxHyp4, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-5', src: vfxHyp5, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-6', src: vfxHyp6, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-7', src: vfxHyp7, category: ['ALL', 'VFX & HYPERLAPSE'] },
  { id: 'vfxHyp-8', src: vfxHyp8, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-9', src: vfxHyp9, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-10', src: vfxHyp10, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-11', src: vfxHyp11, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-12', src: vfxHyp12, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-13', src: vfxHyp13, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-14', src: vfxHyp14, category: ['ALL', 'VFX & HYPERLAPSE'] },
    { id: 'vfxHyp-15', src: vfxHyp15, category: ['ALL', 'VFX & HYPERLAPSE'] },

  // CGI
  { id: 'cgi-1', src: cgi1, category: ['ALL', 'CGI'] },
  { id: 'cgi-2', src: cgi2, category: ['ALL', 'CGI'] },
  { id: 'cgi-3', src: cgi3, category: ['ALL', 'CGI'] },
  { id: 'cgi-4', src: cgi4, category: ['ALL', 'CGI'] },
  { id: 'cgi-5', src: cgi5, category: ['ALL', 'CGI'] },


  // EVENTS
  { id: 'events-1', src: events1, category: ['ALL', 'EVENTS'] },
  { id: 'events-2', src: events2, category: ['ALL', 'EVENTS'] },
  { id: 'events-3', src: events3, category: ['ALL', 'EVENTS'] },
  { id: 'events-4', src: events4, category: ['ALL', 'EVENTS'] },
  { id: 'events-5', src: events5, category: ['ALL', 'EVENTS'] },
  { id: 'events-6', src: events6, category: ['ALL', 'EVENTS'] },
  { id: 'events-7', src: events7, category: ['ALL', 'EVENTS'] },

  // FASHION
  { id: 'fashion-1', src: fashion1, category: ['ALL', 'FASHION'] },
  { id: 'fashion-2', src: fashion2, category: ['ALL', 'FASHION'] },
  { id: 'fashion-3', src: fashion3, category: ['ALL', 'FASHION'] },
  { id: 'fashion-4', src: fashion4, category: ['ALL', 'FASHION'] },
  { id: 'fashion-5', src: fashion5, category: ['ALL', 'FASHION'] },
  { id: 'fashion-6', src: fashion6, category: ['ALL', 'FASHION'] },
  { id: 'fashion-7', src: fashion7, category: ['ALL', 'FASHION'] },
  { id: 'fashion-8', src: fashion8, category: ['ALL', 'FASHION'] },
  { id: 'fashion-9', src: fashion9, category: ['ALL', 'FASHION'] },
  { id: 'fashion-10', src: fashion10, category: ['ALL', 'FASHION'] },

  // FOOD
  { id: 'food-1', src: food1, category: ['ALL', 'FOOD'] },
  { id: 'food-2', src: food2, category: ['ALL', 'FOOD'] },
  { id: 'food-3', src: food3, category: ['ALL', 'FOOD'] },
  { id: 'food-4', src: food4, category: ['ALL', 'FOOD'] },
  { id: 'food-5', src: food5, category: ['ALL', 'FOOD'] },
  { id: 'food-6', src: food6, category: ['ALL', 'FOOD'] },
  { id: 'food-7', src: food7, category: ['ALL', 'FOOD'] },
    { id: 'food-8', src: food8, category: ['ALL', 'FOOD'] },
    { id: 'food-9', src: food9, category: ['ALL', 'FOOD'] },
    { id: 'food-10', src: food10, category: ['ALL', 'FOOD'] },

  // INDUSTRY
  { id: 'industry-1', src: industry1, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-2', src: industry2, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-3', src: industry3, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-4', src: industry4, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-5', src: industry5, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-6', src: industry6, category: ['ALL', 'INDUSTRY'] },
  { id: 'industry-7', src: industry7, category: ['ALL', 'INDUSTRY'] },

  // REAL ESTATE
  { id: 'realestate-1', src: realestate1, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-2', src: realestate2, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-3', src: realestate3, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-4', src: realestate4, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-5', src: realestate5, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-6', src: realestate6, category: ['ALL', 'REAL ESTATE'] },
  { id: 'realestate-7', src: realestate7, category: ['ALL', 'REAL ESTATE'] },
    { id: 'realestate-8', src: realestate8, category: ['ALL', 'REAL ESTATE'] },
    { id: 'realestate-9', src: realestate9, category: ['ALL', 'REAL ESTATE'] },
    { id: 'realestate-10', src: realestate10, category: ['ALL', 'REAL ESTATE'] },

  // SPEEDRAMPING
  { id: 'speed-1', src: speed1, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-2', src: speed2, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-3', src: speed3, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-4', src: speed4, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-5', src: speed5, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-6', src: speed6, category: ['ALL', 'SPEEDRAMPING'] },
  { id: 'speed-7', src: speed7, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-8', src: speed8, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-9', src: speed9, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-10', src: speed10, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-11', src: speed11, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-12', src: speed12, category: ['ALL', 'SPEEDRAMPING'] },
    { id: 'speed-13', src: speed13, category: ['ALL', 'SPEEDRAMPING'] },

];

// Categories array with your specified names
const categories = [
  'VFX & HYPERLAPSE',
  'CGI',
  'EVENTS',
  'FASHION',
  'FOOD',
  'INDUSTRY',
  'REAL ESTATE',
  'SPEEDRAMPING'
];

// ─── 3D COVER FLOW SLIDE COMPONENT ───────────────────────────────
function CoverFlowSlide({
  reel,
  index,
  currentIndex,
  totalSlides,
  isMuted,
  onVideoRef,
  buffering,
  setBuffering,
  goToSlide,
  reducedMotion,
}) {
  const [ref, inView] = useInView({ threshold: 0.1 });
  const videoRef = useRef(null);
  
  // Calculate position relative to center with circular wrapping
  const getCircularPosition = () => {
    const half = Math.floor(totalSlides / 2);
    let pos = index - currentIndex;
    
    // Wrap around for circular behavior
    if (pos > half) pos -= totalSlides;
    if (pos < -half) pos += totalSlides;
    
    return pos;
  };
  
  const position = getCircularPosition();
  const isActive = position === 0;
  const isVisible = Math.abs(position) <= 2; // Show 2 slides on each side
  
  // Calculate 3D transforms based on position with circular awareness
  const getTransform = () => {
    // For positions beyond visible range, hide them
    if (Math.abs(position) > 2) {
      return {
        scale: 0.3,
        translateX: position < 0 ? '-150%' : '150%',
        rotateY: position < 0 ? '45deg' : '-45deg',
        zIndex: 1,
        opacity: 0,
        blur: '5px',
        brightness: 0.3,
        display: 'none',
      };
    }
    
    if (position === 0) {
      // Center slide - full size, no rotation
      return {
        scale: 1,
        translateX: '0%',
        rotateY: '0deg',
        zIndex: 10,
        opacity: 1,
        blur: '0px',
        brightness: 1.2,
      };
    } else if (position === -1) {
      // Left adjacent
      return {
        scale: 0.7,
        translateX: '-70%',
        rotateY: '15deg',
        zIndex: 8,
        opacity: 0.8,
        blur: '1px',
        brightness: 0.8,
      };
    } else if (position === 1) {
      // Right adjacent
      return {
        scale: 0.7,
        translateX: '70%',
        rotateY: '-15deg',
        zIndex: 8,
        opacity: 0.8,
        blur: '1px',
        brightness: 0.8,
      };
    } else if (position === -2) {
      // Second left
      return {
        scale: 0.5,
        translateX: '-120%',
        rotateY: '25deg',
        zIndex: 6,
        opacity: 0.5,
        blur: '2px',
        brightness: 0.6,
      };
    } else if (position === 2) {
      // Second right
      return {
        scale: 0.5,
        translateX: '120%',
        rotateY: '-25deg',
        zIndex: 6,
        opacity: 0.5,
        blur: '2px',
        brightness: 0.6,
      };
    }
    
    return {
      scale: 0.3,
      translateX: position < 0 ? '-150%' : '150%',
      rotateY: position < 0 ? '35deg' : '-35deg',
      zIndex: 4,
      opacity: 0.2,
      blur: '4px',
      brightness: 0.4,
    };
  };

  useEffect(() => {
    if (videoRef.current) {
      onVideoRef(reel.id, videoRef.current);
    }
  }, [reel.id, onVideoRef]);

  // Handle video playback based on visibility and active state
  useEffect(() => {
    if (videoRef.current) {
      if (isActive && inView) {
        videoRef.current.play().catch(() => {});
      } else {
        videoRef.current.pause();
      }
    }
  }, [isActive, inView]);

  const transform = getTransform();

  if (!isVisible && !isActive && Math.abs(position) > 2) return null;

  return (
    <motion.div
      ref={ref}
      className="coverflow-slide"
      initial={false}
      animate={{
        x: transform.translateX,
        scale: transform.scale,
        rotateY: transform.rotateY,
        opacity: transform.opacity,
        filter: `blur(${transform.blur}) brightness(${transform.brightness})`,
        zIndex: transform.zIndex,
      }}
      transition={reducedMotion ? { duration: 0.1 } : {
        type: "spring",
        stiffness: 280,
        damping: 28,
        mass: 1,
      }}
      onClick={() => goToSlide(index)}
    >
      <div className={`slide-content-3d ${isActive ? 'active' : ''}`}>
        {buffering.has(reel.id) && isActive && (
          <div className="buffering-indicator">
            <IoReload className="buffering-spinner" />
          </div>
        )}

        <video
          ref={videoRef}
          src={reel.src}
          muted={isMuted}
          loop={false}
          playsInline
          preload={isActive ? 'auto' : 'metadata'}
          className="coverflow-video"
          onWaiting={() => {
            if (isActive) setBuffering(prev => new Set([...prev, reel.id]));
          }}
          onPlaying={() =>
            setBuffering(prev => {
              const next = new Set(prev);
              next.delete(reel.id);
              return next;
            })
          }
          onEnded={() => {
            if (isActive) {
              // Auto advance to next reel
              goToSlide((currentIndex + 1) % totalSlides);
            }
          }}
        />

        {/* Cinematic overlays */}
        <div className="vignette-overlay" />
        <div className="grain-overlay" />
        
        {/* Reflection effect for side slides */}
        {!isActive && <div className="slide-reflection" />}
      </div>
    </motion.div>
  );
}

// ─── PROGRESS DOTS COMPONENT ─────────────────────────────────────
function ProgressDots({ total, current, onDotClick }) {
  const getVisibleDots = () => {
    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i);
    }
    
    let start = Math.max(0, Math.min(current - 2, total - 5));
    return Array.from({ length: 5 }, (_, i) => start + i);
  };

  const visibleDots = getVisibleDots();
  const showLeftEllipsis = visibleDots[0] > 0;
  const showRightEllipsis = visibleDots[4] < total - 1;

  return (
    <div className="progress-container-3d">
      {showLeftEllipsis && (
        <span className="progress-range-indicator">•••</span>
      )}
      
      <div className="progress-dots-wrapper">
        <div className="progress-dots-scroll">
          {visibleDots.map((dotIndex) => (
            <button
              key={dotIndex}
              onClick={() => onDotClick(dotIndex)}
              className={`progress-dot-3d ${dotIndex === current ? 'active' : ''}`}
              aria-label={`Go to slide ${dotIndex + 1}`}
              aria-current={dotIndex === current ? 'true' : 'false'}
            />
          ))}
        </div>
      </div>

      {showRightEllipsis && (
        <span className="progress-range-indicator">•••</span>
      )}
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────
export default function Carosal() {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [buffering, setBuffering] = useState(new Set());
  const [isDragging, setIsDragging] = useState(false);
  const reducedMotion = useReducedMotion();
  
  const dragStartX = useRef(0);
  const videoRefs = useRef(new Map());
  const containerRef = useRef(null);

  const visibleReels = reels.filter(reel =>
    activeCategory === 'ALL' ? true : reel.category.includes(activeCategory)
  );

  const total = visibleReels.length;
  
  // Reset index when category changes
  useEffect(() => {
    setCurrentIndex(0);
  }, [activeCategory]);

  // Sync mute across all videos
  useEffect(() => {
    videoRefs.current.forEach(video => {
      if (video) video.muted = isMuted;
    });
  }, [isMuted]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prev();
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        next();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex, total]);

  // Navigation functions
  const safeIndex = (idx) => {
    if (total === 0) return 0;
    return ((idx % total) + total) % total;
  };

  const goToSlide = (newIndex) => {
    if (total === 0) return;
    setCurrentIndex(safeIndex(newIndex));
  };

  const next = () => goToSlide(currentIndex + 1);
  const prev = () => goToSlide(currentIndex - 1);

  // Touch/drag navigation
  const handleDragStart = (e) => {
    setIsDragging(true);
    dragStartX.current = e.clientX || (e.touches && e.touches[0].clientX);
  };

  const handleDragEnd = (e) => {
    if (!isDragging) return;
    
    const dragEndX = e.clientX || (e.changedTouches && e.changedTouches[0].clientX);
    if (!dragEndX) return;
    
    const dragDistance = dragEndX - dragStartX.current;
    
    if (Math.abs(dragDistance) > 50) {
      if (dragDistance > 0) {
        prev();
      } else {
        next();
      }
    }
    
    setIsDragging(false);
  };

  const handleVideoRef = (id, el) => {
    if (el) {
      videoRefs.current.set(id, el);
      el.muted = isMuted;
    } else {
      videoRefs.current.delete(id);
    }
  };

  // Handle empty state
  if (total === 0) {
    return (
      <section className="portfolio-hero-3d">
        <div className="categories-container-3d">
          <button className="category-tab-3d active">ALL</button>
        </div>
        <div className="coverflow-container" style={{ perspective: '1200px' }}>
          <div className="coverflow-stage">
            <div style={{ color: 'white', textAlign: 'center' }}>No reels available</div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="portfolio-hero-3d">
      {/* CATEGORY TABS */}
      <div className="categories-container-3d">
        <button
          onClick={() => setActiveCategory('ALL')}
          className={`category-tab-3d ${activeCategory === 'ALL' ? 'active' : ''}`}
        >
          ALL
        </button>

        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setActiveCategory(cat)}
            className={`category-tab-3d ${activeCategory === cat ? 'active' : ''}`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* 3D COVERFLOW CONTAINER */}
      <div 
        ref={containerRef}
        className="coverflow-container"
        onMouseDown={handleDragStart}
        onMouseUp={handleDragEnd}
        onMouseLeave={handleDragEnd}
        onTouchStart={handleDragStart}
        onTouchEnd={handleDragEnd}
        style={{ perspective: '1200px' }}
      >
        <div className="coverflow-stage">
          <AnimatePresence initial={false}>
            {visibleReels.map((reel, idx) => (
              <CoverFlowSlide
                key={reel.id}
                reel={reel}
                index={idx}
                currentIndex={currentIndex}
                totalSlides={total}
                isMuted={isMuted}
                onVideoRef={handleVideoRef}
                buffering={buffering}
                setBuffering={setBuffering}
                goToSlide={goToSlide}
                reducedMotion={reducedMotion}
              />
            ))}
          </AnimatePresence>
        </div>

        {/* Navigation buttons */}
        <button
          onClick={prev}
          className="nav-button-3d prev"
          aria-label="Previous"
        >
          <IoChevronBack size={32} />
        </button>

        <button
          onClick={next}
          className="nav-button-3d next"
          aria-label="Next"
        >
          <IoChevronForward size={32} />
        </button>

        {/* Mute button */}
        <button
          onClick={() => setIsMuted(!isMuted)}
          className="mute-button-3d"
          aria-label={isMuted ? 'Unmute' : 'Mute'}
        >
          {isMuted ? <IoVolumeMute size={24} /> : <IoVolumeHigh size={24} />}
        </button>
      </div>

      {/* Progress dots */}
      <ProgressDots 
        total={total} 
        current={currentIndex} 
        onDotClick={goToSlide}
      />
    </section>
  );
}